import React, { useRef, useState } from "react";
import { Grid, Button, TextField, CircularProgress } from "@mui/material";
import { toast } from "react-toastify";
import { motion } from "framer-motion";
import { ColDef } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import dayjs from "dayjs";
import axiosInterceptorInstance from "../../../utils/axios.interceptor";

const IVRLogs = () => {
  const [data, setData] = useState<any>(null);
  const [pin, setPin] = useState<string>("");

  const [action, setAction] = useState<Boolean>(false);
  const agGridRef = useRef<AgGridReact | null>(null);

  const exportGridDataAsCSV = () => {
    if (agGridRef.current) {
      agGridRef.current.api.exportDataAsCsv();
    }
  };
  const onGridReady = (params: { api: { sizeColumnsToFit: () => void } }) => {
    params.api.sizeColumnsToFit();
  };
  const columnDefs: ColDef[] = [
    {
      field: "origination_number",
      headerName: "Origination Number",
      filter: true,
      resizable: true,
      sortable: true,
    },
    {
      field: "tx_date",
      headerName: "Transaction Date",
      filter: true,
      resizable: true,
      sortable: true,
      valueFormatter: ({ value }) =>
        value && dayjs(value).isValid()
          ? dayjs(value).format("DD-MM-YYYY")
          : "-",
    },
    {
      field: "credit",
      headerName: "Credit",
      filter: true,
      resizable: true,
      sortable: true,
    },
    {
      field: "pin",
      headerName: "PIN",
      filter: true,
      resizable: true,
      sortable: true,
    },
  ];
  const handleGetBundles = async () => {
    setData(null);
    toast.dismiss();
    if (pin.trim() !== "") {
      setAction(true);
      requestBundles();
    } else {
      toast.error("Please Enter  PIN");
    }
  };

  const requestBundles = async () => {
    await axiosInterceptorInstance
      .get(`/product/GetIvrLogByPin?PIN=${pin.trim()}`)
      .then((res: any) => {
        setAction(false);
        const apiresponse = JSON.parse(res.data.body);
        if (apiresponse.data?.length == 0) {
          toast.error("Record not found.");
        } else {
          setData(apiresponse.data);
        }
      })
      .catch((error: any) => {
        setAction(false);
        toast.error(error.message);
      });
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ ease: "linear", duration: 0.5 }}
    >
      <div className="boxShadow">
        <h2 className="sectionTitle">IVR Logs</h2>
        <div className="boxInner">
          <Grid container spacing={2}>
            <Grid item xs={8}>
              <TextField
                className="formControl"
                label="Pin"
                variant="outlined"
                value={pin}
                onChange={(e) => setPin(e.target.value)}
                inputProps={{ maxLength: 40 }}
              />
            </Grid>

            <Grid item xs={4}>
              {!action && (
                <Button
                  onClick={handleGetBundles}
                  className="dButton dButton2"
                  variant="contained"
                >
                  Search
                </Button>
              )}
              {action && (
                <Button className="dButton dButton2" variant="contained">
                  <CircularProgress color="inherit" size={30} />
                </Button>
              )}
            </Grid>
          </Grid>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "5px",
        }}
      >
        <button
          className="small-btn"
          style={{ visibility: data ? "visible" : "hidden" }}
          onClick={() => {
            if (data) {
              exportGridDataAsCSV();
            }
          }}
        >
          Export as CSV
        </button>
      </div>
      {data && (
        <div className="ag-theme-alpine">
          <AgGridReact
            ref={agGridRef}
            paginationPageSize={12}
            pagination={true}
            domLayout="autoHeight"
            rowData={data}
            columnDefs={columnDefs}
            onGridReady={onGridReady}
            enableCellTextSelection={true}
          ></AgGridReact>
        </div>
      )}
    </motion.div>
  );
};

export default IVRLogs;
